module.exports = __webpack_public_path__ + "img/exit_story_card2.733b74c6.svg";